import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import ProvidersEditDialogComponent from './ProvidersEditDialog';
import { STATES } from '../../../store/constants/clients';
import { createProvider, searchFromNPI, updateProvider } from '../../../store/actions/contractProviders';

export const ProvidersEditDialog = connect(
    () => {
        const selectData = (state, props) => props.data;
        const selectMode = (state, props) => {
            return props.data ? 'edit' : 'create';
        }

        function getInitialFormattedState(state, states) {
            const foundState = states.find(item => item.abbreviation === state);
            return foundState ?? null
        }

        const selectInitialValues = createSelector(
            selectMode,
            selectData,
            (mode, provider) => {
                if (mode === 'edit' && provider) {
                    const payload = {
                        id: provider.id,
                        npi: provider.npi,
                        providerName: provider.providerName,
                        providerType: provider.providerType,
                        degree: provider.degree,
                        taxonomyCode: provider.taxonomyCode,
                        specialty: provider.specialty,
                        tin: provider.tin,
                        ein: provider.ein,
                        isActive: provider.isActive,
                        primaryFacility: provider.primaryFacility,
                        state: provider?.state ? getInitialFormattedState(provider?.state, STATES) : null,
                        status: provider.status,
                        npiroleId: provider?.npiroleId
                    }
                    return payload;
                }

                return {
                    npi: '',
                    providerName: '',
                    providerType: '',
                    degree: '',
                    taxonomyCode: '',
                    specialty: '',
                    tin: '',
                    ein: '',
                    isActive: true,
                    primaryFacility: '',
                    state: null,
                    status: '',
                    npiroleId: null
                }
            }
        )

        return (state:any, props) => ({
            mode: selectMode(state, props),
            initialValues: selectInitialValues(state, props),
            providerCreatePending: state.contractProviders.create.pending,
            providerUpdatePending: state.contractProviders.update.pending,
            searchPending: state.contractProviders.search.pending,
            getInitialFormattedState: getInitialFormattedState,
            npiRoles: state.npiRoles.data
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            createProvider: createProvider,
            updateProvider: updateProvider,
            searchFromNPI: searchFromNPI
        }, dispatch)
    })
)(injectIntl(ProvidersEditDialogComponent));